import {connect} from 'react-redux';
import MobileNavigation, {MobileNavigationProps} from '../../components/partials/MobileNavigation';
import {toggleMenu} from '../../actions';

function mapStateToProps(state): Partial<MobileNavigationProps> {
  return {
    gotResults: state.search.hasResults,
    experiments: state.experiments.active,
    show: state.search.toggle
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toggleMenu: state => dispatch(toggleMenu(state))
  };
}

export default <any>connect(mapStateToProps, mapDispatchToProps)(MobileNavigation);
